import React from 'react';

import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from './components/Navbar';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Layout from './components/Layout';
import Section from './components/Section';
import Products from './components/Products';
import Contact from './components/Contact';
import About from './components/About';
import Gallery from './components/Gallery';
import Services from './components/Services';
import Fertilize from './components/Fertilize';
import Distrubion from './components/Distrubion';

function App() {
  return (
    <div className="main">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="*" element={<Layout />} />
          <Route path="/Section" element={<Section />} />
          <Route path="/Products" element={<Products />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/About" element={<About />} />
          <Route path="/Gallery" element={<Gallery />} />
          <Route path="/Services" element={<Services />} />

           <Route path="/Fertilize" element={<Fertilize />} />
            <Route path="/Distrubion" element={<Distrubion />} />


        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
